import { ArrowLeft } from 'lucide-react';
import type { ReactNode } from 'react';
import styles from './PageHeader.module.css';

export type Crumb = { label: string; href?: string };

export const PageHeader = ({
  title,
  context,
  action,
  breadcrumbs = [],
  renderLink,
}: {
  title: string;
  context?: string;
  action?: ReactNode;
  breadcrumbs?: readonly Crumb[];
  renderLink?: (crumb: Crumb) => ReactNode;
}) => (
  <header className={styles['header']}>
    {breadcrumbs.length > 1 ? (
      <nav aria-label="Breadcrumb">
        <ol className={styles['breadcrumbs']}>
          {breadcrumbs.map((crumb, index) => (
            <li
              key={`${crumb.label}-${String(index)}`}
              aria-current={index === breadcrumbs.length - 1 ? 'page' : undefined}
            >
              {index === 0 ? <ArrowLeft size={16} aria-hidden="true" className="flip-inline" /> : null}
              {crumb.href && renderLink ? renderLink(crumb) : crumb.label}
            </li>
          ))}
        </ol>
      </nav>
    ) : null}
    <div className={styles['row']}>
      <div>
        <h1>{title}</h1>
        {context ? <p className={styles['context']}>{context}</p> : null}
      </div>
      {action}
    </div>
  </header>
);
